class IconBlock {
    // Types
    component: HTMLElement;
    observer: IntersectionObserver;

    // Statics
    static animateClass = 'animate';
    static jsEnabled = 'js-enabled';

    // Animation Class Delay Config
    // value is a [initial, x] value pair, initial delay and then for sequential items how much to compound the delay by
    static classDelays = {
        '.icon-block__title': {
            initial: 0,
            following: 0,
        },
        '.icon-block__divider': {
            initial: 200,
            following: 0,
        },
        '.icon-block__intro': {
            initial: 600,
            following: 0,
        },
        '.icon-block__item': {
            initial: 600,
            following: 150,
        },
    };

    // Construct the IconBlock
    constructor(component: HTMLElement) {
        // Set up the Class variables
        this.component = component;
        this.observer = new IntersectionObserver(this.triggerAnimation.bind(this), {
            // Can be quite a tall component, setting to 5% threshold so that animation triggers soon after scrolling over it in either mobile or desktop
            threshold: 0.05,
        });

        // Add js-enabled to prep component for css animations
        this.component.classList.add(IconBlock.jsEnabled);

        // Attach the component to the observer
        this.observer.observe(this.component);
    }

    // Handle when in view, only once
    triggerAnimation(entries: IntersectionObserverEntry[]) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                // Animate all classes, for multiple instances compound the delay
                const delayConfig = IconBlock.classDelays;
                const animationTargets = Object.keys(delayConfig);
                animationTargets.forEach((target) => {
                    const {initial, following} = delayConfig[target];
                    const elems = this.component.querySelectorAll(target);

                    elems.forEach((elem, index) => {
                        setTimeout(
                            () => {
                                elem.classList.add(IconBlock.animateClass);
                            },
                            index ? initial + following * index : initial,
                        );
                    });
                });

                // We've animated, observer no longer needs to observe
                this.observer.disconnect();
            }
        });
    }
}

export default IconBlock;
